export default __webpack_public_path__ + "49ac363f8ae9b7430770926806f3b861.png";